import Vue from "vue";
import VueMeta from "vue-meta";
import App from "./App";
import router from "./router";
import VueMaterial from "vue-material";
import Vuex from "vuex";
import axios from "axios";
import VueI18n from "vue-i18n";
import VuePageTransition from "vue-page-transition";
import moment from "moment/min/moment-with-locales";
import VueAwesomeSwiper from "vue-awesome-swiper";
//import VueModalTor from "vue-modaltor";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
Vue.use(CoolLightBox);
import _ from "lodash";
Object.defineProperty(Vue.prototype, "$_", { value: _ });
import VueStar from "vue-star";
import * as VueGoogleMaps from "vue2-google-maps";
import NoData from "@/modules/NoData";
import CustomAlert from "@/components/CustomAlert";
import VueTheMask from "vue-the-mask";
import { VueStars } from "vue-stars";
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";

import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import "./assets/theme/index.css";
//import 'element-ui/lib/theme-chalk/index.css'
import $ from "jquery";
import wb from "./registerServiceWorker";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { lightbox } from "lightbox2";
import "lightbox2/dist/css/lightbox.css";

import { Message } from "element-ui";

import ICS from "vue-ics";
Vue.use(ICS);
Vue.use(LottieAnimation);

Vue.prototype.$workbox = wb;
Vue.use(ElementUI, { locale });

import "swiper/css/swiper.css";

import { tr } from "./language/tr.js";
import { en } from "./language/en.js";

import store from "./store/store";

import PortalVue from "portal-vue";
Vue.use(PortalVue);
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

const io = require("socket.io-client");

Vue.prototype.$errorMessage = (key, validationErrors) => {
  if (validationErrors == null && validationErrors == undefined) return null;
  if (validationErrors.some(k => k.key == key)) {
    return validationErrors.find(k => k.key == key).value;
  } else {
    return null;
  }
};

Vue.prototype.getEnumsDisplay = function(category, key) {
  return this.$store.getters.getEnums.find(x => x.title == category).enums.find(x => x.key == key).displayName;
};
Vue.prototype.$inputError = (key, validationErrors) => {
  if (validationErrors.some(k => k.key == key)) {
    return "has-error-input";
  } else {
    return "";
  }
};

// require("./assets/js/plyr.min");
// require("./assets/js/flv.min");
// require("./assets/js/dash.all.min");
// require("./assets/js/hls");

import "./assets/css/plyr-ui.css";

var AddToCalendar = require("vue-add-to-calendar");

Vue.use(AddToCalendar);
Vue.use(VueMeta, {
  keyName: "metaInfo",
  attribute: "data-vue-meta",
  ssrAttribute: "data-vue-meta-server-rendered",
  tagIDKeyName: "vmid",
  refreshOnceOnNavigation: true
});

Vue.component("vue-phone-number-input", VuePhoneNumberInput);
axios.defaults.baseURL = "https://api.holacon.com/v2/";
//axios.defaults.baseURL = "http://localhost:5010/v2/";
// axios.defaults.baseURL = "http://178.233.224.8:5010/v2/";
// axios.defaults.baseURL = "http://192.168.1.199:5010/v2/";
// axios.defaults.baseURL = "http://94.55.179.1:5010//v2/";


Vue.prototype.$toCamel = function toCamel(o) {
  var newO, origKey, newKey, value;
  if (o instanceof Array) {
    return o.map(function(value) {
      if (typeof value === "object") {
        value = toCamel(value);
      }
      return value;
    });
  } else {
    newO = {};
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
        value = o[origKey];
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = toCamel(value);
        }
        newO[newKey] = value;
      }
    }
  }
  return newO;
};

Vue.prototype.$getModuleTitle = function getModuleTitle(modules, moduleName) {
  return lang == "tr" ? modules.find(x => x.name == moduleName).titleTr : modules.find(x => x.name == moduleName).title;
};

Vue.prototype.$imageus = "https://img.imageus.dev/";

Vue.prototype.$socket = io("https://socket.holacon.com", {
  transports: ["websocket"],
  upgrade: false,
  query: {
    token: localStorage.getItem("token")
  },
  reconnectionDelay: 500,
  reconnectionDelayMax: 1000,
  reconnectionAttempts: 1000
});

var subscribedChannels = [];

Vue.prototype.$socket.on("subscribe_success", data => {
  if (!subscribedChannels.some(x => x == data)) {
    subscribedChannels.push(data);
  }
});

Vue.prototype.$socket.on("unsubscribe_success", data => {
  if (data != null && data != undefined) {
    subscribedChannels = subscribedChannels.filter(x => x != data);
  }
});

Vue.prototype.$socket.on("connected", data => {
  store.commit("setConnected", true);

  for (let i = 0; i < subscribedChannels.length; i++) {
    const channel = subscribedChannels[i];
    Vue.prototype.$socket.emit("subscribe", {
      channel: channel,
      token: localStorage.getItem("token") != null ? localStorage.getItem("token") : null
    });
  }
});

Vue.prototype.$socket.on("disconnect", data => {
  store.commit("setConnected", false);
});

Vue.prototype.$socket.on("error", function() {
  store.commit("setConnected", false);
});

Vue.prototype.$socket.on("connect_error", function() {
  store.commit("setConnected", false);
  setTimeout(() => {
    Vue.prototype.$socket.connect();
  }, 1000);
});

const messages = {
  tr,
  en
};

Vue.use(VueI18n);
Vue.use(Vuex);
Vue.use(VueMaterial);
Vue.use(VuePageTransition);
Vue.use(VueAwesomeSwiper);
//Vue.use(VueModalTor);
Vue.component("VueStar", VueStar);
Vue.component("Nodata", NoData);
Vue.component("CustomAlert", CustomAlert);
Vue.component("vue-stars", VueStars);
Vue.use(VueTheMask);

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (401 === error.response.status) {
      if (error.response.config.url == "account/get") {
        localStorage.removeItem("token");
        store.commit("setToken", null);
        router.push(store.state.application.slug);
      } else {
        // Message.info(this.$t("loginFirst"));
      }
      error.response = {
        ...error.response,
        data: {
          hasError: true,
          message: i18n.t("loginFirst")
        }
      };
      return error.response;
    } else {
      return Promise.reject(error);
    }
  }
);

import VueTour from "vue-tour";

require("vue-tour/dist/vue-tour.css");

Vue.prototype.$tourOptions = {
  labels: {
    buttonSkip: "Tanıtımı Geç",
    buttonPrevious: "Önceki",
    buttonNext: "Sonraki",
    buttonStop: "Bitir"
  }
};

Vue.prototype.$checkBrowser = () => {
  var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;
  if (isOpera) return "opera";

  var isFirefox = typeof InstallTrigger !== "undefined";
  if (isFirefox) return "firefox";

  var isSafari =
    /constructor/i.test(window.HTMLElement) ||
    (function(p) {
      return p.toString() === "[object SafariRemoteNotification]";
    })(!window["safari"] || (typeof safari !== "undefined" && safari.pushNotification));
  if (isSafari) return "safari";

  var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
  if (isChrome) return "chrome";

  return null;
};
Vue.prototype.getLocaleDate = date => {
  var offset = new Date(date).getTimezoneOffset();
  var newDate = moment(date).add(offset, "minutes");
  return newDate;
};
Vue.prototype.$helpLinks = {
  chrome: "https://support.google.com/chrome/answer/2693767?co=GENIE.Platform%3DDesktop&hl=tr",
  mozilla: "https://support.mozilla.org/tr/kb/how-manage-your-camera-and-microphone-permissions",
  opera: "https://help.opera.com/en/latest/web-preferences/#camera",
  safari: "https://support.apple.com/tr-tr/guide/safari/ibrwe2159f50/mac"
};

Vue.use(VueTour);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyA7RBvU7GcWXCc8Yl_ObPBL2HhJEGZkQTg"
  },
  installComponents: true
});

var lang = localStorage.getItem("lang");
if (lang == null) {
  lang = navigator.language || navigator.userLanguage;
  lang = lang.substr(0, 2);

  if (lang != "en" && lang != "tr") {
    lang = "en";
  }
}

const i18n = new VueI18n({
  locale: lang,
  messages
});

moment.locale(lang, {
  relativeTime: {
    asd: "%dd"
  }
});

axios.defaults.headers["Authorization"] = localStorage.getItem("token") == null ? undefined : "Bearer " + localStorage.getItem("token");

axios.defaults.headers["language"] = lang;

Vue.config.productionTip = false;

const guestRoutes = ["login", "register", "forgot-password", "start"];

var scrollTimeout = null;
router.beforeEach(async (to, from, next) => {
  if (scrollTimeout != null) clearTimeout(scrollTimeout);
  scrollTimeout = setTimeout(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, 500);

  if (store.state.application != null && to.params.slug != null && to.params.slug != undefined && store.state.application.slug != to.params.slug) {
    store.state.application = null;
  }

  if (store.state.application == null) {
    var mainLiveUrls = "test01.internative.net,test001.internative.net,test1.internative.net,live.holacon.com,localhost,95.70.231.49".split(",");
    if ((store.state.lastApplication != null || store.state.lastApplication != undefined) && mainLiveUrls.some(x => x == window.location.hostname)) {
      var res = null;
      if (to.params.slug != undefined && to.params.slug != null) {
        res = await axios.post("login/getapplication", { id: to.params.slug }).catch(async err => {
          //Bu url bizde tanımlı değil. ana ekrana yönlendiriyoruz.
          localStorage.removeItem("lastApplication");
          window.location.href = "/";
        });
      } else {
        res = await axios.post("login/getapplication", { id: store.state.lastApplication }).catch(async err => {
          //Bu url bizde tanımlı değil. ana ekrana yönlendiriyoruz.
          localStorage.removeItem("lastApplication");
          window.location.href = "/";
        });
      }
      if (res.data.hasError) {
        //GetApplication da bir hata var ana ekrana.
        localStorage.removeItem("lastApplication");
        window.location.href = "/";
      } else {
        //Domain bizde tanımlı
        store.commit("setApplication", res.data.data);
        localStorage.setItem("lastApplication", res.data.data.slug);
      }
    } else if (mainLiveUrls.some(x => x == window.location.hostname)) {
      //Holacon live açılıyor
      if (to.params.slug != undefined) {
        //Parametre olarak bir slug var sluga ait application'ı alıyoruz.
        var res = await axios.post("login/getapplication", { id: to.params.slug }).catch(async err => {
          //Bu url bizde tanımlı değil. ana ekrana yönlendiriyoruz.
          window.location.href = "/";
        });
        if (res.data.hasError) {
          //GetApplication da bir hata var ana ekrana.
          window.location.href = "/holacon";
        } else {
          //Domain bizde tanımlı
          store.commit("setApplication", res.data.data);
          localStorage.setItem("lastApplication", res.data.data.slug);
        }
      } else {
        var res = await axios.post("login/getapplication", { id: "holacon" }).catch(async err => {
          //Bu url bizde tanımlı değil. 404 sayfasına yönlendiriyoruz.
          //window.location.href = "/404";
        });
        if (res.data.hasError) {
          //GetApplication da bir hata var 404 e gönderiyoruz.
          window.location.href = "/holacon";
        } else {
          //Holacon default açılıyor, domain live ve slug yok
          store.commit("setApplication", res.data.data);
          localStorage.setItem("lastApplication", res.data.data.slug);
        }
      }
    } else {
      //Farklı bir domainden istek geliyor, white-label
      var res = await axios.post("login/getapplication", { id: window.location.hostname }).catch(async err => {
        //Bu url bizde tanımlı değil. 404 sayfasına yönlendiriyoruz.
        window.location.href = "/";
      });
      if (res.data.hasError) {
        //Bu url bizde tanımlı değil. 404 sayfasına yönlendiriyoruz.
        window.location.href = "/";
      } else {
        //Domain bizde tanımlı
        store.commit("setApplication", res.data.data);
        localStorage.setItem("lastApplication", res.data.data.slug);
      }
    }
    // return next({ name: "home", params: { slug: store.state.application.slug } });
  }
  if (to.params.slug == undefined || to.params.slug == null) {
    return next({ name: "home", params: { slug: store.state.application.slug } });
  }
  if (to.params.slug != store.state.application.slug) {
    return next({ name: "home", params: { slug: store.state.application.slug } });
  }

  if (to.query.activationCode != null && to.query.activationCode != undefined) {
    //Hızlı giriş kodu mevcut, logine gönderiliyor.
    if (to.fullPath != "/" + store.state.application.slug + "/login?activationCode=" + to.query.activationCode) {
      return next({ path: "/" + store.state.application.slug + "/login?activationCode=" + to.query.activationCode });
    }
  }

  //Hızlı girişi otomatik tetikleme kodu
  if (to.query.code != undefined) {
    setTimeout(() => {
      if (window.vm.$store.state.token != null) {
        window.vm.$store.dispatch("activateEvent", to.query.code);
      } else {
        localStorage.setItem("code", to.query.code);
      }
    }, 500);
  }

  if (store.state.event == null && to.params.id) {
    await store.dispatch("getEventBySlug", { id: null, slug: to.params.id });
  }

  if (guestRoutes.indexOf(to.name) == -1 && (store.state.token == null || store.state.user == null || store.state.application == null)) {
    if (store.state.user == null && store.state.token != null) {
      var response = await axios.post("account/get");
      if (response.status == 401) {
        localStorage.removeItem("token");
        store.commit("setToken", null);
      } else {
        if (!response.data.hasError) {
          store.commit("setUser", response.data.data.user);
          store.commit("setNotify", response.data.data);
        }
      }
    }

    return next();
  }

  return next();
});

import VueAnalytics from "vue-analytics";
//and then use it in main.js
Vue.use(VueAnalytics, {
  id: "G-9XGRN5PN2P",
  router
});

window.vm = new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  store,
  i18n
});

Vue.config.errorHandler = (err, vm, info) => {
  console.log(err);
};



// WEBPACK FOOTER //
// ./src/main.js